import inputmask from '../../Global/AsyncModules/inputmask';

export default () => {
    document.querySelectorAll('.sidebar-selection-price .from-to').forEach((main) => {
        const minVal = main.dataset.min;
        const maxVal = main.dataset.max;

        const inputs = main.querySelectorAll('.input__control');

        inputs.forEach((input) => {
            inputmask(input, {
                alias: 'integer',
                min:minVal,
                max:maxVal,
                placeholder:'',
                allowMinus: false,
                autoGroup: true,
                groupSize: 3,
                groupSeparator: ' ',
                clearMaskOnLostFocus: false,
                removeMaskOnSubmit: true
            })
        });

        // FormData also covers submission before the asynchronous mask has loaded.
        main.closest('form').addEventListener('formdata', (event) => {
            inputs.forEach((input) => {
                const value = event.formData.get(input.name);
                if (typeof value === 'string') {
                    event.formData.set(input.name, value.replace(/\s/g, ''));
                }
            });
        });
    });
}




// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/fromTo.js